import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { initMetaPixel } from './lib/metaPixel';
import { Hero } from './components/Hero';
import { Gancho } from './components/Gancho';
import { Problema } from './components/Problema';
import { IntentosFallidos } from './components/IntentosFallidos';
import { Mecanismo } from './components/Mecanismo';
import { Entregables } from './components/Entregables';
import { ParaQuien } from './components/ParaQuien';
import { ComoFunciona } from './components/ComoFunciona';
import { Prueba } from './components/Prueba';
import { FAQ } from './components/FAQ';
import { Oferta } from './components/Oferta';
import { Footer } from './components/Footer';
import { Shield } from 'lucide-react';
export function App() {
  const [showSticky, setShowSticky] = useState(false);
  // Initialize Meta Pixel and fire PageView on page load
  useEffect(() => {
    initMetaPixel();
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past hero section (approx 600px)
      if (window.scrollY > 600) {
        setShowSticky(true);
      } else {
        setShowSticky(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <main className="min-h-screen bg-navy-800 font-sans text-offwhite overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <Gancho data-id="element-2" />
      <Problema data-id="element-3" />
      <IntentosFallidos data-id="element-4" />
      <Mecanismo data-id="element-5" />
      <Entregables data-id="element-6" />
      <ParaQuien data-id="element-7" />
      <ComoFunciona data-id="element-8" />
      <Prueba data-id="element-9" />
      <FAQ data-id="element-10" />
      <Oferta data-id="element-11" />
      <Footer data-id="element-12" />

      {/* Sticky CTA Bar */}
      <AnimatePresence data-id="element-13">
        {showSticky && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} className="fixed bottom-0 left-0 w-full z-50 p-4 bg-navy-900/90 backdrop-blur-md border-t border-gold/20 shadow-[0_-10px_30px_rgba(11,20,48,0.8)]" data-id="element-14">
            <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-15">
              <div className="hidden md:flex items-center gap-3" data-id="element-16">
                <Shield className="text-gold" size={24} data-id="element-17" />
                <div data-id="element-18">
                  <p className="font-serif font-bold text-offwhite leading-none" data-id="element-19">
                    Botiquín de Emergencia Post-Oficina
                  </p>
                  <p className="text-gold text-sm" data-id="element-20">$14.000 ARS</p>
                </div>
              </div>

              <button onClick={scrollToPricing} className="w-full sm:w-auto bg-gold hover:bg-gold-light text-navy-900 font-serif font-bold px-8 py-3 rounded-sm transition-colors shadow-[0_0_15px_rgba(201,169,97,0.3)]" data-id="element-21">
                ¡QUIERO MI BOTIQUÍN AHORA!
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </main>;
}